module.exports = __webpack_public_path__ + "static/img/s8.914c4a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/s8.png
// module id = QFi1
// module chunks = 1